import { render, staticRenderFns } from "./index.vue?vue&type=template&id=93caf034&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=93caf034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93caf034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93caf034')) {
      api.createRecord('93caf034', component.options)
    } else {
      api.reload('93caf034', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=93caf034&scoped=true", function () {
      api.rerender('93caf034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XrAvatar/index.vue"
export default component.exports